/**
 * Configurator — copy-link and social-share drawers
 */

(function () {
  'use strict';

  var COPY_RESET_MS = 2500;
  var OPEN_CLASS = 'is-open';
  var BODY_CLASS = 'sp-modal-open';

  var copyResetTimer = null;
  var lastTrigger = null;
  var openModal = null;
  var inertRoots = [];

  function getDrawer(modal) {
    return modal ? modal.querySelector('[role="dialog"]') || modal.querySelector('.sp-modal-drawer') : null;
  }

  function activateTrap(container, focusEl) {
    if (typeof trapFocus === 'function') {
      trapFocus(container, focusEl || container);
      return;
    }
    if (focusEl && focusEl.focus) focusEl.focus();
  }

  function deactivateTrap() {
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
  }

  function setPageInert(exceptEl, isInert) {
    if (!isInert) {
      inertRoots.forEach(function (child) {
        child.removeAttribute('inert');
      });
      inertRoots = [];
      return;
    }

    inertRoots = [];
    Array.prototype.forEach.call(document.body.children, function (child) {
      if (child === exceptEl) {
        child.removeAttribute('inert');
        return;
      }
      child.setAttribute('inert', '');
      inertRoots.push(child);
    });
  }

  function closeOtherShareDialogs() {
    if (window.ConfiguratorEmailBuild && typeof window.ConfiguratorEmailBuild.close === 'function') {
      window.ConfiguratorEmailBuild.close({ silent: true });
    }
  }

  function getShareUrl() {
    if (window.ConfiguratorUrlState && typeof window.ConfiguratorUrlState.buildShareUrl === 'function') {
      try {
        return window.ConfiguratorUrlState.buildShareUrl();
      } catch (e) {
        /* fall through */
      }
    }
    return window.location.href;
  }

  function getShareText(modal) {
    if (modal && modal.dataset.shareText) return modal.dataset.shareText;
    var product = window.configuratorSettings && window.configuratorSettings.product;
    if (product && product.title) return 'Check out my ' + product.title + ' build';
    return document.title;
  }

  function networkUrl(network, url, text) {
    var encodedUrl = encodeURIComponent(url);
    var encodedText = encodeURIComponent(text);
    switch (network) {
      case 'facebook':
        return 'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl;
      case 'x':
        return 'https://twitter.com/intent/tweet?url=' + encodedUrl + '&text=' + encodedText;
      case 'pinterest':
        return 'https://pinterest.com/pin/create/button/?url=' + encodedUrl + '&description=' + encodedText;
      case 'linkedin':
        return 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodedUrl;
      case 'whatsapp':
        return 'https://api.whatsapp.com/send?text=' + encodeURIComponent(text + ' ' + url);
      default:
        return url;
    }
  }

  function setCopyState(state) {
    var button = document.querySelector('#cfg-copy-link-modal .js-cfg-copy-link-btn');
    if (!button) return;
    var label = button.querySelector('.js-share-copy-label');
    var status = button.querySelector('.js-share-copy-status');
    var spinner = button.querySelector('.loading__spinner');
    var isLoading = state === 'loading';
    var isCopied = state === 'copied';

    button.classList.toggle('loading', isLoading);
    button.classList.toggle('is-copied', isCopied);
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
    if (label) {
      var defaultLabel = label.dataset.defaultLabel || 'Copy link';
      var copiedLabel = label.dataset.copiedLabel || 'Copied';
      label.textContent = isCopied ? copiedLabel : defaultLabel;
    }
    if (status) {
      status.textContent = isCopied && window.accessibilityStrings
        ? window.accessibilityStrings.shareSuccess
        : '';
    }
  }

  function resetCopyFeedback() {
    clearTimeout(copyResetTimer);
    setCopyState('idle');
  }

  function hydrateCopyModal(url) {
    var input = document.querySelector('#cfg-copy-link-modal .js-cfg-copy-link-input');
    if (input) input.value = url;
    resetCopyFeedback();
  }

  function getVisibleBuildLayers() {
    var container = document.querySelector('.configurator__image');
    if (!container) return [];
    return Array.prototype.filter.call(container.querySelectorAll('img'), function (img) {
      var style = window.getComputedStyle(img);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      if (parseFloat(style.opacity) === 0) return false;
      return !!(img.currentSrc || img.src);
    });
  }

  function renderBuildPreview(modal) {
    var layers = getVisibleBuildLayers();
    var fallback = (modal && modal.dataset.previewImage) || '';

    modal.querySelectorAll('.js-cfg-preview-build').forEach(function (host) {
      host.innerHTML = '';
      if (!layers.length && fallback) {
        var fallbackImg = document.createElement('img');
        fallbackImg.src = fallback;
        fallbackImg.alt = '';
        host.appendChild(fallbackImg);
        return;
      }
      layers.forEach(function (img) {
        var clone = document.createElement('img');
        var computed = window.getComputedStyle(img);
        clone.src = img.currentSrc || img.src;
        clone.alt = '';
        clone.className = img.className;
        if (computed.filter && computed.filter !== 'none') {
          clone.style.filter = computed.filter;
        }
        if (computed.opacity && computed.opacity !== '1') {
          clone.style.opacity = computed.opacity;
        }
        host.appendChild(clone);
      });
    });
  }

  function compactUrl(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.host + parsed.pathname.replace(/\/$/, '');
    } catch (e) {
      return url;
    }
  }

  function hydratePreview(modal, url) {
    var text = getShareText(modal);
    var title = modal.dataset.previewTitle || document.title;
    var domain = modal.dataset.previewDomain || window.location.host;
    var displayUrl = compactUrl(url);

    modal.querySelectorAll('.js-cfg-preview-text').forEach(function (el) {
      el.textContent = text;
    });
    modal.querySelectorAll('.js-cfg-preview-title').forEach(function (el) {
      el.textContent = title;
    });
    modal.querySelectorAll('.js-cfg-preview-domain').forEach(function (el) {
      el.textContent = domain;
    });
    modal.querySelectorAll('.js-cfg-preview-url').forEach(function (el) {
      el.textContent = displayUrl;
    });
    renderBuildPreview(modal);
  }

  function selectSocialNetwork(network) {
    var modal = document.getElementById('cfg-social-share-modal');
    if (!modal) return;
    var selected = null;

    modal.querySelectorAll('.js-cfg-social-share-link').forEach(function (btn) {
      var isActive = btn.dataset.network === network;
      btn.classList.toggle('is-selected', isActive);
      btn.setAttribute('aria-checked', isActive ? 'true' : 'false');
      btn.tabIndex = isActive ? 0 : -1;
      if (isActive) selected = btn;
    });

    var stage = modal.querySelector('.js-cfg-preview-stage');
    var fromHeight = stage ? stage.offsetHeight : 0;
    var shouldAnimate = modal.classList.contains('is-open') &&
      fromHeight > 0 &&
      !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    modal.querySelectorAll('.js-cfg-preview-panel').forEach(function (panel) {
      var isActive = panel.dataset.network === network;
      panel.classList.toggle('is-active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    if (stage) {
      var nextPanel = stage.querySelector('.js-cfg-preview-panel.is-active');
      var toHeight = nextPanel ? nextPanel.offsetHeight : 0;

      if (shouldAnimate && toHeight && fromHeight !== toHeight) {
        stage.style.height = fromHeight + 'px';
        stage.offsetHeight;
        stage.style.height = toHeight + 'px';

        var onPreviewHeightEnd = function (event) {
          if (event && event.propertyName && event.propertyName !== 'height') return;
          stage.removeEventListener('transitionend', onPreviewHeightEnd);
          stage.style.height = '';
        };
        stage.removeEventListener('transitionend', onPreviewHeightEnd);
        stage.addEventListener('transitionend', onPreviewHeightEnd);
      } else {
        stage.style.height = '';
      }
    }

    var confirm = modal.querySelector('.js-cfg-social-share-confirm');
    var confirmLabel = confirm && confirm.querySelector('.js-cfg-social-share-confirm-label');
    if (confirm) {
      confirm.dataset.network = network;
      if (confirmLabel) confirmLabel.textContent = (selected && selected.dataset.shareLabel) || 'Share';
    }

    var live = modal.querySelector('.js-cfg-social-preview-live');
    if (live && selected) {
      var platform = (selected.querySelector('.cfg-social-share__label') || {}).textContent || network;
      var template = modal.dataset.previewing || 'Previewing __PLATFORM__';
      live.textContent = template.replace('__PLATFORM__', platform.trim());
    }
  }

  function getVisibleNetworkButtons(modal) {
    return Array.prototype.filter.call(modal.querySelectorAll('.js-cfg-social-share-link'), function (btn) {
      return !btn.hidden && !btn.closest('[hidden]');
    });
  }

  function onNetworkKeydown(event) {
    var keys = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'];
    if (keys.indexOf(event.key) === -1) return;

    var modal = document.getElementById('cfg-social-share-modal');
    if (!modal) return;
    var buttons = getVisibleNetworkButtons(modal);
    if (!buttons.length) return;

    var current = document.activeElement;
    var index = buttons.indexOf(current);
    if (index < 0) {
      current = modal.querySelector('.js-cfg-social-share-link[aria-checked="true"]') || buttons[0];
      index = buttons.indexOf(current);
    }

    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = buttons.length - 1;
    else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      index = index <= 0 ? buttons.length - 1 : index - 1;
    } else {
      index = index >= buttons.length - 1 ? 0 : index + 1;
    }

    event.preventDefault();
    selectSocialNetwork(buttons[index].dataset.network);
    buttons[index].focus();
  }

  function hydrateSocialModal(url) {
    var modal = document.getElementById('cfg-social-share-modal');
    if (!modal) return;
    hydratePreview(modal, url);
    if (!modal.querySelector('.js-cfg-social-share-link.is-selected')) {
      selectSocialNetwork('facebook');
    } else {
      var current = modal.querySelector('.js-cfg-social-share-link.is-selected');
      selectSocialNetwork(current.dataset.network);
    }
  }

  function confirmSocialShare() {
    var modal = document.getElementById('cfg-social-share-modal');
    var confirm = modal && modal.querySelector('.js-cfg-social-share-confirm');
    var network = confirm && confirm.dataset.network;
    var url = getShareUrl();
    var text = getShareText(modal);

    if (!network) return;
    window.open(networkUrl(network, url, text), '_blank', 'noopener,noreferrer');
  }

  function isDisplayed(el) {
    if (!el) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function resolveFocusTarget(preferred, selector) {
    if (isDisplayed(preferred)) return preferred;
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (isDisplayed(nodes[i])) return nodes[i];
    }
    return preferred || nodes[0] || null;
  }

  function triggerSelector(trigger) {
    if (trigger && trigger.classList.contains('js-configurator-social-share-btn')) {
      return '.js-configurator-social-share-btn';
    }
    if (trigger && trigger.classList.contains('js-configurator-share-build-btn')) {
      return '.js-configurator-share-build-btn';
    }
    return '.js-configurator-share-build-btn, .js-configurator-social-share-btn';
  }

  function setTriggerExpanded(trigger, isOpen) {
    var controls = trigger && trigger.getAttribute('aria-controls');
    document.querySelectorAll('.js-configurator-share-build-btn, .js-configurator-social-share-btn').forEach(function (btn) {
      var match = isOpen && controls && btn.getAttribute('aria-controls') === controls;
      btn.setAttribute('aria-expanded', match ? 'true' : 'false');
    });
  }


  function closeShareModal(options) {
    if (!openModal) return;
    var restoreFocus = !options || !options.silent;
    var trigger = resolveFocusTarget(lastTrigger, triggerSelector(lastTrigger));
    deactivateTrap();
    openModal.classList.remove(OPEN_CLASS);
    openModal.setAttribute('hidden', '');
    document.body.classList.remove(BODY_CLASS);
    setPageInert(null, false);
    setTriggerExpanded(null, false);
    openModal = null;
    if (restoreFocus && trigger) trigger.focus();
  }

  function openShareModal(modal, trigger) {
    if (!modal) return;
    if (openModal && openModal !== modal) closeShareModal({ silent: true });
    closeOtherShareDialogs();

    var url = getShareUrl();
    if (modal.id === 'cfg-copy-link-modal') hydrateCopyModal(url);
    if (modal.id === 'cfg-social-share-modal') hydrateSocialModal(url);

    lastTrigger = trigger || lastTrigger;
    openModal = modal;
    modal.classList.add(OPEN_CLASS);
    modal.removeAttribute('hidden');
    document.body.classList.add(BODY_CLASS);
    setTriggerExpanded(trigger, true);
    setPageInert(modal, true);

    var drawer = getDrawer(modal);
    var firstControl = drawer && drawer.querySelector('.js-cfg-share-modal-close, .sp-modal-close');
    if (drawer) activateTrap(drawer, firstControl || drawer);
  }

  function onKeyDown(event) {
    if (!openModal) return;
    if (event.key !== 'Escape' && event.key !== 'Esc' && event.code !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
    closeShareModal();
  }

  function copyLink() {
    var url = getShareUrl();
    hydrateCopyModal(url);
    setCopyState('loading');

    var write = navigator.clipboard && typeof navigator.clipboard.writeText === 'function'
      ? navigator.clipboard.writeText(url)
      : Promise.reject(new Error('clipboard unavailable'));

    write.then(function () {
      setCopyState('copied');
      clearTimeout(copyResetTimer);
      copyResetTimer = setTimeout(function () {
        setCopyState('idle');
      }, COPY_RESET_MS);
    }).catch(function () {
      setCopyState('idle');
      var input = document.querySelector('#cfg-copy-link-modal .js-cfg-copy-link-input');
      var status = document.querySelector('#cfg-copy-link-modal .js-share-copy-status');
      var modal = document.getElementById('cfg-copy-link-modal');
      if (input) {
        input.focus();
        input.select();
      }
      if (status) {
        status.textContent = (modal && modal.dataset.copyManual) ||
          'Clipboard is unavailable. The link is selected so you can copy it with your keyboard.';
      }
    });
  }

  function bindTriggers(selector, modalId) {
    document.querySelectorAll(selector).forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.setAttribute('aria-haspopup', 'dialog');
      btn.setAttribute('aria-controls', modalId);
      btn.addEventListener('click', function () {
        var modal = document.getElementById(modalId);
        if (openModal === modal) {
          closeShareModal();
          return;
        }
        openShareModal(modal, btn);
      });
    });
  }

  function init() {
    var copyModal = document.getElementById('cfg-copy-link-modal');
    var socialModal = document.getElementById('cfg-social-share-modal');
    if (!copyModal && !socialModal) return;

    [copyModal, socialModal].forEach(function (modal) {
      if (!modal) return;
      document.body.appendChild(modal);
      modal.addEventListener('click', function (event) {
        if (event.target === modal) closeShareModal();
      });
    });

    document.querySelectorAll('.js-cfg-share-modal-close').forEach(function (btn) {
      btn.addEventListener('click', closeShareModal);
    });

    var copyButton = document.querySelector('#cfg-copy-link-modal .js-cfg-copy-link-btn');
    if (copyButton) copyButton.addEventListener('click', copyLink);

    document.querySelectorAll('.js-cfg-social-share-link').forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectSocialNetwork(btn.dataset.network);
      });
    });

    var networkGroup = document.querySelector('#cfg-social-share-modal [role="radiogroup"]');
    if (networkGroup) networkGroup.addEventListener('keydown', onNetworkKeydown);

    var confirm = document.querySelector('.js-cfg-social-share-confirm');
    if (confirm) confirm.addEventListener('click', confirmSocialShare);

    bindTriggers('.js-configurator-share-build-btn', 'cfg-copy-link-modal');
    bindTriggers('.js-configurator-social-share-btn', 'cfg-social-share-modal');
    document.addEventListener('keydown', onKeyDown, true);
  }

  window.ConfiguratorShareModals = {
    close: closeShareModal,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
